import React, { useEffect, useState } from 'react'
import { Button, DatePicker, Input, Space, Table, message } from 'antd';
import bookingService from '../../services/booking.service';
import { EditTwoTone, MailTwoTone, PhoneTwoTone, SearchOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import authService from '../../services/auth.service';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

export default function BookingList({ currentStatus }) {

    dayjs.extend(utc);
    const navigate = useNavigate();
    const [bookings, setBookings] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [selectedCreatedDate, setSelectedCreatedDate] = useState(null);
    const [acceptLoading, setAcceptLoading] = useState({});
    const [rejectLoading, setRejectLoading] = useState({});
    const [selectedReservationDate, setSelectedReservationDate] = useState(null);
    const [searchString, setSearchString] = useState(null);

    useEffect(() => {
        fetchBookings();
    }, [pageSize, pageNumber, currentStatus, selectedReservationDate, selectedCreatedDate]);

    const fetchBookings = () => {
        bookingService
            .getAllBookings(pageSize, pageNumber, currentStatus, selectedReservationDate, selectedCreatedDate, searchString)
            .then((result) => {
                if (result.status === 200) {
                    const mappedBookings = result.data.items.map((booking, index) => ({
                        key: index,
                        id: booking.id,
                        name: booking.customerFirstName + ' ' + booking.customerLastName,
                        childName: booking.childName,
                        customerEmail: booking.customerEmail,
                        phoneNumber: booking.customerPhoneNumber,
                        note: booking.note,
                        createdAt: booking.createdAt,
                        from: booking.from,
                        to: booking.to,
                        packageName: booking.package.packageName,
                        playroomId: booking.playroom.id,
                        expectedNumberOfAdults: booking.expectedNumberOfAdults,
                        expectedNumberOfChildren: booking.expectedNumberOfChildren,
                        specialOffers: booking.specialOffers,
                        reservationCode: booking.reservationCode,
                        food: booking.food,
                        paymentMethod: booking.paymentMethod,
                    }));

                    setTotalItems(result.data.totalItems);
                    setBookings(mappedBookings);
                    console.log(result.data);
                }
            }).catch((err) => {
                console.log(err);
            })
    }
    const columns = [
        {
            title: 'Ime',
            dataIndex: 'name',
            key: 'name',
            className: 'text-base',
            render: (record) => { return <p className="text-lg font-semibold text-footerBlue">{record}</p> }
        },
        {
            title: 'Kod',
            dataIndex: 'reservationCode',
            key: 'reservationCode',
            render: (record) => { return <p className="text-lg font-semibold text-footerBlue">{record}</p> }, // Apply consistent font size
        },
        ...(currentStatus === 'PENDING' ? [
            {
                title: 'Dani od rezervacije',
                key: 'dateBeforePayment',
                render: (record) => checkDateStatus(record.createdAt),
                className: 'text-base', // Apply consistent font size
            }
        ] : []),
        ...(currentStatus !== 'REJECTED' ? [
            {
                title: 'Akcija',
                key: 'action',
                render: (record) => renderActions(record),
                className: 'text-base', // Apply consistent font size
            }
        ] : []),
    ];

    const handleReject = (id) => {
        setRejectLoading(prevState => ({ ...prevState, [id]: true }));
        bookingService.rejectReservation(id)
            .then((result) => {
                if (result.status === 200) {
                    fetchBookings();


                }
            }).catch((err) => {
                console.log("err");
            }).finally(() => {
                setRejectLoading(prevState => ({ ...prevState, [id]: false }));
            });

        message.error("Rezervacija odbijena!");
    }

    const handleAccept = (id) => {
        setAcceptLoading(prevState => ({ ...prevState, [id]: true }));
        bookingService.confirmReservation(id)
            .then((result) => {
                if (result.status === 200) {
                    fetchBookings();
                }
            }).catch((err) => {
                console.log("err");
            }).finally(() => {
                setAcceptLoading(prevState => ({ ...prevState, [id]: false }));

            });
        message.success("Uspješno ste odobrili rezervaciju!");
    }

    const handleEdit = (bookingId, playroomId) => {
        console.log("edit -- ", playroomId);
        navigate(`/update-booking/${bookingId}/${playroomId}`);
    }

    const renderActions = (record) => {
        if (currentStatus === 'PENDING') {
            return (
                <div className="flex justify-center items-center space-x-2">
                    <Button
                        type="primary"
                        className="text-sm font-semibold"
                        style={{
                            background: "green"
                        }}
                        onClick={() => handleAccept(record.id)}
                        loading={acceptLoading[record.id] === true}  // Set the loading state for this button
                    >Prihvati</Button>
                    <Button type="primary"
                        className="text-sm font-semibold"
                        danger
                        loading={rejectLoading[record.id] === true}
                        onClick={() => handleReject(record.id)}>Odbaci</Button>
                    <Button
                        type="primary"
                        onClick={() => handleEdit(record.id, record.playroomId)}
                        className="text-sm font-semibold">Izmjeni</Button>
                </div>
            );
        } else if (currentStatus === 'RESERVED') {
            return (
                <Button
                    type="primary"
                    className="text-sm font-semibold"
                    danger
                    onClick={() => handleReject(record.id)}
                >
                    Odbij
                </Button>
            );
        }
    };

    const handleSearchClick = () => {
        console.log("Triggered search: ", searchString);
        fetchBookings();
    };

    const checkDateStatus = (timestamp) => {
        const currentDate = new Date();
        const givenDate = new Date(timestamp);

        const differenceInTime = currentDate.getTime() - givenDate.getTime();
        const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24)); // 1000 ms/s * 3600 s/h * 24 h/day

        if (differenceInDays > 5) {

            return <div className="flex justify-center items-center space-x-2"><Tag className='text-base font-semibold' color="red">{`${differenceInDays} dana`}</Tag></div>; // Red tag if older than 5 days
        } else {
            return <div className="flex justify-center items-center space-x-2"><Tag className='text-base font-semibold' color="green">{`${differenceInDays} dana`}</Tag></div>; // Green tag if within 5 days
        }
    };

    const onChangeCreatedDate = (date, dateString) => {
        console.log(date, dateString);
        setSelectedCreatedDate(date ? dateString : null);
    };

    const onChangeReservationDate = (date, dateString) => {
        console.log(date, dateString);
        setSelectedReservationDate(date ? dateString : null);
    };

    const handleTableChange = (pagination) => {
        setPageNumber(pagination.current); // Update page number on pagination change
        setPageSize(pagination.pageSize);  // Update page size if the user changes it
    };

    const formatDate = (timestamp) => {
        return dayjs.utc(timestamp).format("DD.MM.YYYY");
    };

    const formatTime = (timestamp) => {
        return dayjs.utc(timestamp).format("HH:mm");
    };

    const getPaymentsMethod = (paymentMethod) => {
        if (paymentMethod === "INVOICE_PAYMENT") {
            return "Žiro račun";
        }
        return "Gotovina";
    };

    return (
        <div className="container mx-auto px-4 py-4"> {/* Add responsive container */}
            <div className="flex mb-4 space-x-4">
                <div className="flex space-x-4">
                    <DatePicker
                        placeholder="Odaberi datum kreiranja"
                        className="text-lg h-12 w-52"
                        onChange={onChangeCreatedDate}
                        allowClear
                    />
                    <DatePicker
                        placeholder="Odaberi datum rezervacije"
                        className="text-lg h-12 w-52"
                        onChange={onChangeReservationDate}
                        allowClear
                    />
                </div>
                <div className="flex space-x-4">
                    <Input
                        placeholder="Unesi ime"
                        className="text-lg h-12 w-52"
                        onChange={(e) => setSearchString(e.target.value)}
                        allowClear
                    />
                    <Button
                        type="primary"
                        className="h-12 text-base font-semibold"
                        icon={<SearchOutlined />}
                        onClick={handleSearchClick}
                    >
                        Pretraži
                    </Button>
                </div>
            </div>
            <div className="bg-white p-4 shadow rounded-lg"> {/* Add padding and background for the table */}
                <Table
                    columns={columns}
                    expandable={{
                        expandedRowRender: (record) => (
                            <div className="flex flex-col space-y-2 p-4 bg-gray-50 rounded-lg text-base">
                                <p className="flex items-center space-x-2 text-gray-600">
                                    <span className="font-medium">Izabrani paket: <Tag className="text-base"
                                        color="blue">{record.packageName}</Tag></span>
                                </p>
                                <p className="flex items-center space-x-2 text-gray-600">
                                    <span className="font-medium">Datum i vrijeme kreiranja rezervacije: <Tag
                                        className="text-base"
                                        color="blue">{`${formatDate(record.createdAt)} ${formatTime(record.createdAt)}`}</Tag></span>
                                </p>
                                <p className="flex items-center space-x-2 text-gray-600">
                                    <span className="font-medium">Datum i vrijeme rezervacije: <Tag
                                        className="text-base"
                                        color="blue">{`${formatDate(record.from)} ${formatTime(record.from)} - ${formatTime(record.to)}`}</Tag></span>
                                </p>

                                <p className="flex items-center space-x-2 text-gray-600">
                                    <span className="font-medium">Ime slavljenika: <Tag className="text-base"
                                        color="blue">{record.childName}</Tag></span>
                                </p>
                                <p className="flex items-center space-x-2 text-gray-600">
                                    <MailTwoTone />
                                    <span className="font-medium">{record.customerEmail}</span>
                                </p>
                                <p className="flex items-center space-x-2 text-gray-600">
                                    <PhoneTwoTone />
                                    <span className="font-medium">{record.phoneNumber}</span>
                                </p>
                                <p className="flex items-center space-x-2 text-gray-600">
                                    <span className="font-medium">Broj odraslih: <Tag className="text-base"
                                        color="blue">{record.expectedNumberOfAdults}</Tag></span>
                                </p>
                                <p className="flex items-center space-x-2 text-gray-600">
                                    <span className="font-medium">Broj djece: <Tag className="text-base"
                                        color="blue">{record.expectedNumberOfChildren}</Tag></span>
                                </p>
                                <p className="flex items-center space-x-2 text-gray-600">
                                    <span className="font-medium">Hrana: <Tag className="text-base"
                                        color="blue">{record.food}</Tag></span>
                                </p>
                                <p className="flex items-center space-x-2 text-gray-600">
                                    <span className="font-medium">Način plaćanja: <Tag className="text-base"
                                        color="blue">{getPaymentsMethod(record.paymentMethod)}</Tag></span>
                                </p>
                                <p className="flex items-center space-x-2 text-gray-600">
                                    <EditTwoTone />
                                    <span
                                        className="font-medium">{record.note || "Napomena koju koristimo samo kako bi smo je vidjeli na dizajnu!"}</span>
                                </p>




                            </div>
                        ),
                        rowExpandable: (record) => record.name !== 'Not Expandable',
                    }}
                    dataSource={bookings}
                    pagination={{
                        current: pageNumber,
                        pageSize: pageSize,
                        showSizeChanger: false,
                        total: totalItems,
                    }}
                    onChange={handleTableChange}
                />
            </div>
        </div>
    )
}
